import i18n from 'live/services/i18n'
import widgetService from 'live/services/widgets'
import { reactWidgetWrapper } from 'live/widgets/decorators/react'
import LollipopWidgetController from './LollipopWidgetController'
import { lollipopReducer } from './reducer'

const type = 'lollipop'

const LollipopWidget = reactWidgetWrapper<ChartState, FlowMessage<ChartEvent>, Configs>(
    LollipopWidgetController,
    lollipopReducer,
    {
        mapConfigToProps(configs) {
            return {
                widget: configs.widget
            }
        }
    }
)

const DEFAULT_CHART_CONFIG: LiveWidgetConfig = {
    hideTooltip: false,
    verticalEnabled: true,
    legendEnabled: false,
    tooltipType: 'DEFAULT'
}

widgetService.register({
    type,
    get name() {
        return i18n('Lollipop')
    },
    get description() {
        return i18n('Lollipop')
    },
    config: DEFAULT_CHART_CONFIG,
    impl: LollipopWidget
})
